import React, { useState } from "react";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { parApi, parErr, parPref } from "@/lib/partnerApi";
import WorkflowContent from "@/components/nds/windows/finance/WorkflowContent";
import { btnGreen } from "@/components/nds/windows/finance/parts";

function ConvertBox({ rec, reload }) {
  const [busy, setBusy] = useState(false);
  if (rec.status !== "accepted") return null;
  if (rec.resident_id) return <div data-testid="par-ref-converted" className="text-sm text-emerald-300">Converted to resident record · {rec.converted_at?.slice(0, 10)}</div>;
  const convert = async () => {
    setBusy(true);
    try { const d = await parApi.post(`/referrals/${rec.id}/convert`); toast.success(`Resident ${d.resident.first_name} ${d.resident.last_name} created`); reload(); }
    catch (e) { toast.error(parErr(e)); } finally { setBusy(false); }
  };
  return <button type="button" disabled={busy} onClick={convert} data-testid="par-ref-convert" className={`${btnGreen} inline-flex items-center gap-1.5`}><UserPlus className="h-3 w-3" /> Convert to resident</button>;
}

const OPEN = ["submitted", "reviewing"];
const CFG = {
  key: "referrals", api: "/referrals", client: parApi, pref: parPref, testid: "par-ref", label: "Referral", plural: "referrals",
  saOnly: true, noLedger: true, noDocs: true,
  summaryTone: "yellow", summaryText: (s) => `${s.submitted} submitted · ${s.reviewing} reviewing`,
  chips: { submitted: ["yellow", "Submitted"], reviewing: ["blue", "Reviewing"], accepted: ["green", "Accepted"], declined: ["red", "Declined"], withdrawn: ["darkgrey", "Withdrawn"] },
  form: [{ k: "submitted_by", label: "Submitted by (partner)", type: "partner", partnerTypes: ["org_ambassador"] }, { k: "referral_date", label: "Referral date", type: "date" },
    { k: "first_name", label: "First name", type: "text" }, { k: "last_name", label: "Last name", type: "text" }, { k: "phone", label: "Phone", type: "text", optional: true },
    { k: "email", label: "Email", type: "email", optional: true }, { k: "age", label: "Age", type: "number", optional: true },
    { k: "situation_summary", label: "Situation summary", type: "text", wide: true }],
  actions: [
    { name: "review", label: "Start review", from: ["submitted"], sa: true, tone: "blue" },
    { name: "accept", label: "Accept", from: OPEN, sa: true, tone: "green" },
    { name: "decline", label: "Decline", from: OPEN, sa: true, tone: "red", note: true, placeholder: "Decision notes (required)" },
    { name: "withdraw", label: "Mark withdrawn", from: OPEN, sa: true, tone: "red" },
  ],
  row: (r) => <><span className="text-nex-silver font-medium">{r.first_name} {r.last_name}</span><span className="font-mono text-[10px] text-nex-muted">{r.referral_date}</span><span className="text-xs text-nex-muted truncate max-w-[220px]">by {r.partner_name}</span></>,
  amount: (r) => <span className="text-xs text-nex-muted">{r.age ? `age ${r.age}` : ""}</span>,
  title: (r) => `${r.first_name} ${r.last_name}`,
  fields: (r) => [["Submitted by", r.partner_name], ["Referral date", r.referral_date], ["Phone", r.phone], ["Email", r.email], ["Age", r.age], ["Situation", r.situation_summary],
    ["Reviewed", r.reviewed_at && `${r.reviewed_by?.name} · ${r.reviewed_at.slice(0, 10)}`], ["Decision notes", r.decision_notes]],
  Extra: ({ rec, reload }) => <ConvertBox rec={rec} reload={reload} />,
};
export default function ParReferralsContent() { return <WorkflowContent cfg={CFG} />; }
